import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { EmptyList, Loading } from "../../../components";
import { useLazyScans } from "../hooks";
import { parseSearchParams } from "../../../helpers/clean-object";
import { SearchScanInput } from "../components/search";
import { ScansTable } from "../components/scans-table";
import { formatDate } from "../../../helpers/date";

export const Scans: React.FC = () => {
  const navigate = useNavigate();
  const limit = 9999;
  const [searchParams] = useSearchParams();

  const [search, { data, loading, fetchMore, error, refetch }] = useLazyScans();

  React.useEffect(() => {
    search({
      variables: {
        limit,
        offset: 0,
        where: parseSearchParams(searchParams),
      },
    });
  }, [searchParams]);

  return (
    <>
      <div className="main-container">
        <SearchScanInput {...parseSearchParams(searchParams)} />

        <div className="card mb-2">
          {loading ? <Loading /> : null}
          {data?.scans?.results?.length && data?.scans?.results?.length > 0 ? (
            <ScansTable
              iData={
                data?.scans?.results?.map((scan) => ({
                  date: formatDate(scan.createdAt),
                  imgUrl: scan?.product?.imgUrl,
                  product: scan.product,
                  site: scan.site,
                  price: scan.price + " €",
                  priceVariation: scan.priceVariation + " €",
                  quantity: scan.quantity + " pcs",
                  sales: scan.sales + " pcs",
                  restocking: scan.restocking + " pcs",
                  ca: scan.ca.toFixed(2) + " €",
                })) || []
              }
            />
          ) : (
            <EmptyList text="Aucune analyse trouvée" />
          )}
        </div>

        {data?.scans?.hasMore && (
          <div className="w-full px-4 flex items-center justify-center">
            <div
              className="cursor-pointer inline-flex items-center justify-center px-2 h-8 text-xs text-white bg-indigo-500 rounded"
              onClick={() => {
                fetchMore({
                  variables: {
                    offset: data?.scans?.results?.length,
                    limit,
                    where: parseSearchParams(searchParams),
                  },
                });
              }}
            >
              Charger Plus
            </div>
          </div>
        )}
      </div>
    </>
  );
};

//  <div className="flex flex-wrap -mx-4 items-center justify-between mb-2">
//    <div className="w-full lg:w-1/3 px-4 flex items-center mb-4 lg:mb-0"></div>
//    <div className="w-full lg:w-auto px-4 flex items-center justify-end">
//      <button className="btn" onClick={() => refetch()}>
//        <svg
//          xmlns="http://www.w3.org/2000/svg"
//          width="21"
//          height="21"
//          viewBox="0 0 24 24"
//          fill="white"
//        >
//          <path d="M13.5 2c-5.621 0-10.211 4.443-10.475 10h-3.025l5 6.625 5-6.625h-2.975c.257-3.351 3.06-6 6.475-6 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-1.863 0-3.542-.793-4.728-2.053l-2.427 3.216c1.877 1.754 4.389 2.837 7.155 2.837 5.79 0 10.5-4.71 10.5-10.5s-4.71-10.5-10.5-10.5z" />
//        </svg>
//      </button>
//    </div>
//  </div>;
